import { IKartDetails, TKartFormValues } from "../types/kart.type";
import * as Joi from "joi";
import { sharingBasisEnum } from "../types/dmc.types";
import { z, ZodEnum } from "zod";
// import { UseFormSetError } from "react-hook-form";

export enum TransferTypeEnum {
  Oneway = "oneway",
  Return = "return",
}

export const transferSchema = Joi.object({
  id: Joi.number().optional(),
  // sharingType: Joi.number().required(),
  // sharingType: Joi.string().required(),
  sharingType: Joi.string()
    .valid(sharingBasisEnum.sharing, sharingBasisEnum.private)
    .required(),
  date: Joi.date().required(),
  time: Joi.string().required(),
  mongoDb_siteId: Joi.string(),
  driverId: Joi.number().optional().allow(null),
  pickupLocation: Joi.string().required(),
  dropLocation: Joi.string().required(),
  internalRemark: Joi.string().allow(""),
  remarkForCustomer: Joi.string().allow(""),
  kartId: Joi.number().optional().allow(null),
  internalDriverCharges: Joi.number().optional(),
  isCompleted: Joi.boolean().optional().default(false),
  completedAt: Joi.date().optional().allow(null),
})
  .optional()
  .allow(null);

export const kartSchema = Joi.object({
  id: Joi.number().optional(),
  customerId: Joi.number().required(),
  kartName: Joi.string().required(),

  adults: Joi.number().required(),
  child: Joi.number().required(),
  infant: Joi.number().required(),

  arrivalDate: Joi.date().required(),

  quoteValidyInDays: Joi.number().required().optional().allow(null),

  accomodations: Joi.array().items(
    Joi.object({
      id: Joi.number().optional(),
      accomodationId: Joi.number().required(),
      noOfNights: Joi.number().required(),
      checkinDate: Joi.date().required(),
      time: Joi.string().optional().allow(""),
      numberOfRooms: Joi.number().required(),
      price: Joi.number().required(),
      internalRemark: Joi.string().optional().allow(""),
      remarkForCustomer: Joi.string().optional().allow(""),
      singleRoomPrice: Joi.number().optional(),
      singleRoomCount: Joi.number().optional(),
      doubleRoomPrice: Joi.number().optional(),
      doubleRoomCount: Joi.number().optional(),
      extraAdultPrice: Joi.number().optional(),
      extraAdultCount: Joi.number().optional(),
      childWBed: Joi.number().optional(),
      childWBedCount: Joi.number().optional(),
      childWoBed: Joi.number().optional(),
      childWoBedCount: Joi.number().optional().allow(null),
      pickupTransfer: transferSchema,
      dropTransfer: transferSchema,
      pickupTransferId: Joi.number().optional().allow(null),
      dropTransferId: Joi.number().optional().allow(null),
      purchaseConfirmationNo: Joi.string().allow("").allow(null),
      salesConfirmationNo: Joi.string().allow("").allow(null),
      accomodation: Joi.any().optional(),
      bookedByCustomer: Joi.boolean().required(),
      transferType: Joi.string()
        .valid("oneway", "return")
        .allow("")
        .label("Transfer type")
        .allow(null)
        .optional(),
      sharingBasis: Joi.string()
        .valid(
          sharingBasisEnum.sharing,
          sharingBasisEnum.private,
          sharingBasisEnum.dp_pvt_pk_pvt,
          sharingBasisEnum.dp_pvt_pk_sic,
          sharingBasisEnum.dp_sic_pk_pvt,
          sharingBasisEnum.dp_sic_pk_sic
        )
        .optional()
        .allow(null)
        .allow(""),
      transferPrice: Joi.number().optional(),
    })
  ),
  activities: Joi.array().items(
    Joi.object({
      id: Joi.number().optional(),
      activityId: Joi.number().required(),
      tourOptionId: Joi.number().required(),
      transferType: Joi.string()
        .valid("oneway", "return")
        .allow("")
        .label("Transfer type")
        .allow(null)
        .optional(),
      sharingBasis: Joi.string()
        .valid(
          sharingBasisEnum.private,
          sharingBasisEnum.sharing,
          sharingBasisEnum.dp_pvt_pk_pvt,
          sharingBasisEnum.dp_pvt_pk_sic,
          sharingBasisEnum.dp_sic_pk_pvt,
          sharingBasisEnum.dp_sic_pk_sic
        )
        .optional()
        .allow(null)
        .allow(""),
      activity: Joi.any().optional(),
      tourOption: Joi.any().optional(),
      pickupTransferId: Joi.number().optional().allow(null),
      dropTransferId: Joi.number().optional().allow(null),
      // returnTransferId: Joi.number().optional(),
      pickupTransfer: transferSchema,
      dropTransfer: transferSchema,
      price: Joi.number().required(),
      // dayIndex: Joi.number().optional().allow(""),
      remarkForCustomer: Joi.string().optional().allow("").allow(null),
      internalRemark: Joi.string().optional().allow("").allow(null),
      startDate: Joi.date().optional().allow(null),
      time: Joi.string().optional().allow(null),
      purchaseConfirmationNo: Joi.string().allow("").allow(null),
      salesConfirmationNo: Joi.string().allow("").allow(null),
      // startDateTime: Joi.date().optional().allow(null),
    })
  ),
  miscellaneous: Joi.array().items(
    Joi.object({
      id: Joi.number().optional(),
      name: Joi.string().required().label("Name"),
      description: Joi.string().label("Description").allow(""),
      price: Joi.number().required().label("Price"),
      startDate: Joi.date().optional().allow(null),
      time: Joi.string().optional().allow(null),
      // startDateTime: Joi.date().optional().allow(null),
      remarkForCustomer: Joi.string().optional().allow("").allow(null),
      internalRemark: Joi.string().optional().allow("").allow(null),
      purchaseConfirmationNo: Joi.string().allow("").allow(null),
      salesConfirmationNo: Joi.string().allow("").allow(null),
    })
  ),
  flightDetails: Joi.array().items(
    Joi.object({
      id: Joi.number().optional(),
      airlineCode: Joi.string().required().label("Airline Code"),
      flightNo: Joi.string().required().label("Flight No"),
      description: Joi.string().label("Description").allow(""),
      price: Joi.number().required().label("Price"),
      origin: Joi.string().required().label("Origin"),
      destination: Joi.string().required().label("Destination"),
      depDate: Joi.date().optional().allow(null),
      depTime: Joi.string().optional().allow(null),
      arrDate: Joi.date().optional().allow(null),
      arrTime: Joi.string().optional().allow(null),
      pnr: Joi.string().optional().allow(""),
      remarkForCustomer: Joi.string().optional().allow("").allow(null),
      internalRemark: Joi.string().optional().allow("").allow(null),
      purchaseConfirmationNo: Joi.string().allow("").allow(null),
      salesConfirmationNo: Joi.string().allow("").allow(null),
      bookedByCustomer: Joi.boolean().required(),
    })
  ),
  passengers: Joi.array().items(
    Joi.object({
      id: Joi.number().optional(),
      kartId: Joi.number().optional(),
      firstName: Joi.string().label("First Name").allow(""),
      lastName: Joi.string().label("Last Name").allow(""),
      title: Joi.string().required().label("Title"),
      dateOfBirth: Joi.date().optional().label("Date of Birth").allow(null),
      paxType: Joi.string().optional().allow(""),
      createdAt: Joi.any().optional(),
      updatedAt: Joi.any().optional(),
    })
  ),
  totalPrice: Joi.number().required(),
  serviceCharge: Joi.number().optional().label("Service Charge"),
  remittanceCharge: Joi.number().optional().label("Remittance Charge"),
  discount: Joi.number().optional().label("Discount"),
  remark: Joi.string().allow("").label("Remark"),
  // priceBreakup: Joi.string().valid(...Object.values(PriceBreakupEnum)),
  // priceBreakup: Joi.string().valid(Object.values(PriceBreakupEnum).toString()),
  priceBreakup: Joi.string().valid("full", "partial", "none", "noprice"),
  quotationId: Joi.string().allow(""),
  noOfDays: Joi.number().required().max(90).label("No of Days"),
  noOfNights: Joi.number().required().max(90).label("No of Nights"),
  isVouchered: Joi.boolean().optional().default(false),
  isCancelled: Joi.boolean().optional().default(false),
  purchaseConfirmationNo: Joi.string().allow("").allow(null),
  salesConfirmationNo: Joi.string().allow("").allow(null),
  paymentDeadline: Joi.date().optional().allow(null).allow(""),
  collectedPayment: Joi.number().optional().allow(null),
  internalRemark: Joi.string().optional().allow(""),
  remarkForCustomer: Joi.string().optional().allow(""),
  currencySymbol: Joi.string(),
  isAgentBranding: Joi.boolean().optional().default(false),
});

export const accomodationSchema = Joi.object({
  id: Joi.number().optional(),
  name: Joi.string().required().label("Name"),
  address: Joi.string().required().label("Address"),
  area: Joi.string().optional().allow(null, "").label("Area"),
  cityId: Joi.number().required().label("City"),
  phoneNumber: Joi.string().optional().allow(null, "").label("Phone Number"),
  transfer: transferSchema,
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .optional()
    .allow(null, "")
    .label("Email"),
});

export const driverSchema = Joi.object({
  id: Joi.number().optional(),
  driverName: Joi.string().required().label("Driver Name"),
  phone: Joi.string().allow(""),
});

export const transferLocationSchema = Joi.object({
  id: Joi.number().optional(),
  location: Joi.string().required().label("Location"),
});

export const activitySchema = Joi.object({
  id: Joi.number().optional(),
  name: Joi.string().required().label("Activity Name"),
  // type: Joi.string()
  //   .required()
  //   .valid("transfer", "sightseeing", "meal")
  //   .label("Activity Type"),
  description: Joi.string()
    .allow("", null)
    .label("Descripton")
    .label("Activity Description"),
  cityId: Joi.number().required(),
});

export const tourOptionsSchema = Joi.object({
  activityId: Joi.number().required().label("Activity Id"),
  tourOptions: Joi.array()
    .items(
      Joi.object({
        id: Joi.number().optional(),
        name: Joi.string().required().label("Name").label("Tour Option Name"),
        description: Joi.string().label("Description").optional().allow(""),
        hasTimeSlots: Joi.boolean().label("Has Time Slots").optional(),
        hasMeal: Joi.boolean().label("Has Time Slots").optional(),
        hasGuide: Joi.boolean().label("Has Time Slots").optional(),
        hasTicket: Joi.boolean().label("Has Time Slots").optional(),
        pickupPickupTime: Joi.string()
          .label("Pickup Pickup Time")
          .optional()
          .allow(null),
        dropPickupTime: Joi.string()
          .label("Drop Pickup Time")
          .optional()
          .allow(null),
      })
    )
    .required(),
});

export const validateKartDetails = (
  data: TKartFormValues,
  // setError: UseFormSetError<TKartFormValues>
  setError?: any
) => {
  let isValidated = true;
  let toastError = "";
  if (
    data.activities.length +
      data.accomodations.length +
      data.miscellaneous.length ===
    0
  ) {
    isValidated = false;
    toastError = "Please select atleast one itinerary";
  }

  const addedAdults =
    data.passengers?.filter((pax) => pax.paxType === "adult").length || 0;
  const addedChildren =
    data.passengers?.filter((pax) => pax.paxType === "child").length || 0;
  const addedInfant =
    data.passengers?.filter((pax) => pax.paxType === "infant").length || 0;
  if (
    addedAdults > data.adults ||
    addedChildren > data.child ||
    addedInfant > data.infant
  ) {
    isValidated = false;
    toastError = "Passenger count mismatch, please reselect passengers.";
  }

  // collected payment should not be greater than total price
  if ((data.collectedPayment || 0) > data.totalPrice) {
    isValidated = false;
    toastError = "Collected payment should not be greater than total price";
  }

  data.activities.forEach((activity, index) => {
    if (data.isVouchered) {
      if (!activity.startDate) {
        if (setError) {
          setError(`activities.${index}.startDate`, {
            type: "date.required",
            message: "Please select start date for all activities",
          });
        }
        isValidated = false;
      }
      if (activity.transferType === TransferTypeEnum.Oneway) {
        if (!activity.pickupTransfer) {
          toastError = "Please add pickup transfer for activity";
          isValidated = false;
        }
      }
      if (activity.transferType === TransferTypeEnum.Return) {
        if (!activity.pickupTransfer || !activity.dropTransfer) {
          toastError = "Please add transfer for activity";
          isValidated = false;
        }
      }
    }
    if (activity.transferType && !activity.sharingBasis) {
      toastError = "Please select sharing basis for activity";
      isValidated = false;
    }
  });
  data.accomodations.forEach((accm, index) => {
    if (data.isVouchered) {
      if (accm.transferType === TransferTypeEnum.Oneway) {
        if (!accm.pickupTransfer) {
          toastError = "Please add pickup transfer for accomodation";
          isValidated = false;
        }
      }
      if (accm.transferType === TransferTypeEnum.Return) {
        if (!accm.pickupTransfer || !accm.dropTransfer) {
          toastError = "Please add transfer for accomodation";
          isValidated = false;
        }
      }
    }
    if (accm.transferType && !accm.sharingBasis) {
      toastError = "Please select sharing basis for accomodation";
      isValidated = false;
    }
  });
  data.miscellaneous.forEach((misc, index) => {
    if (data.isVouchered) {
      if (!misc.startDate) {
        if (setError) {
          setError(`miscellaneous.${index}.startDate`, {
            type: "date.required",
            message: "Please select start date for all miscellaneous",
          });
        }
        isValidated = false;
      }
    }
  });

  return { isValidated, toastError };
};

export const tourOptionTicketRatesSchema = Joi.object({
  tourOptionId: Joi.number().required(),
  marketId: Joi.number().required(),
  // mongoDbSiteId: Joi.string().required(),
  adultAmount: Joi.number().required(),
  childAmount: Joi.number().required(),
  isPerPax: Joi.boolean().required(),
  validFromDate: Joi.string().required(),
  validTillDate: Joi.string().required(),
});

export const zodTourOptionTransferRatesSchema = z
  .object({
    amount: z.number().nonnegative().describe("Amount is required"),
    description: z.string().min(1).describe("Description is required"),
    isPerPax: z.boolean().describe("isPerPax is required"),
    marketId: z.number().nonnegative().describe("Market ID is required"),
    maxPax: z.number().nullable().describe("Max Pax is required"),
    minPax: z.number().nullable().describe("Min Pax is required"),
    tourOptionId: z
      .number()
      .nonnegative()
      .describe("Tour Option ID is required"),
    transferType: z.string().min(1).describe("Transfer Type is required"),
    sharingBasis: z
      .enum([sharingBasisEnum.private, sharingBasisEnum.sharing])
      .describe("Sharing Basis is required"),
    validFromDate: z.string().date(),
    validTillDate: z.string().date(),
  })
  .superRefine((val, ctx) => {
    if (val.sharingBasis === sharingBasisEnum.private) {
      if (typeof val.minPax !== "number") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["minPax"],
          message: "minPax must be required if sharingBasis is 'private'",
        });
      }
      if (typeof val.maxPax !== "number") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["maxPax"],
          message: "maxPax must be required if sharingBasis is 'private'",
        });
      }
    }
  });

export type IDmcTourOptionTransferRate = z.infer<
  typeof zodTourOptionTransferRatesSchema
>;

export const getTourOptionPriceForQuotationBuilderRequest = Joi.object({
  tourOptionId: Joi.number(),
  selectedmarketId: Joi.number(),
  transferType: Joi.string().valid("oneway", "return").optional().allow(null),
  noOfAdults: Joi.number(),
  noOfChildren: Joi.number(),
  activityDate: Joi.string(),
  sharingBasis: Joi.string()
    .valid(
      sharingBasisEnum.private,
      sharingBasisEnum.sharing,
      sharingBasisEnum.dp_pvt_pk_pvt,
      sharingBasisEnum.dp_pvt_pk_sic,
      sharingBasisEnum.dp_sic_pk_pvt,
      sharingBasisEnum.dp_sic_pk_sic
    )
    .optional()
    .allow(null),
});
